import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link, useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { password } from '@koyomi/shared';
import { Button, Input } from '@koyomi/ui';
import { AuthCard } from './AuthCard.tsx';
import { api, ApiError } from '../../lib/api.ts';

const schema = z.object({ password });

export function ResetPasswordPage() {
  const { t } = useTranslation(['auth', 'common']);
  const [params] = useSearchParams();
  const [done, setDone] = useState(false);
  const form = useForm<z.infer<typeof schema>>({ resolver: zodResolver(schema), defaultValues: { password: '' } });
  const onSubmit = form.handleSubmit(async (values) => {
    try {
      await api('/auth/reset-password', { body: { token: params.get('token') ?? '', password: values.password }, global: true });
      setDone(true);
    } catch (err) {
      form.setError('root', { message: err instanceof ApiError ? err.message : t('common:errors.INTERNAL') });
    }
  });
  return (
    <AuthCard title={t('auth:reset.title')}>
      {done ? (
        <p>{t('auth:reset.done')}</p>
      ) : (
        <form className="k-stack" onSubmit={onSubmit} noValidate>
          <Input label={t('auth:reset.password')} type="password" autoComplete="new-password" autoFocus {...form.register('password')} error={form.formState.errors.password && t('common:errors.VALIDATION_ERROR')} />
          {form.formState.errors.root && <div className="k-field__error" role="alert">{form.formState.errors.root.message}</div>}
          <Button type="submit" variant="primary" size="lg" block loading={form.formState.isSubmitting}>{t('auth:reset.submit')}</Button>
        </form>
      )}
      <Link to="/login" style={{ textAlign: 'center' }}>{t('auth:login.submit')}</Link>
    </AuthCard>
  );
}
